import * as z from "zod/v4";
import { literal } from "zod/v4";
import { ConfirmDiscountBubble } from "../../agents/support-agents/confirm-discount-bubble";
import { ContentType } from "../../conversation";
import { BaseMessageDbParser } from "../base-conversation-message-db-parser";
import { AutoGeneratedFieldsSchema } from "../message-parser-utils";
/**
 * Message type to show a copyable discount code
 */
const DiscountCodeMessageSchema = BaseMessageDbParser.extend({
  contentType: literal(ContentType.DISCOUNT_CODE),
  structuredContent: ConfirmDiscountBubble.optional(),
});
export type NewDiscountCodeMessage = z.infer<typeof DiscountCodeMessageSchema>;

export const DiscountCodeMessageDbParser = DiscountCodeMessageSchema.merge(
  AutoGeneratedFieldsSchema,
);
export type DiscountCodeMessageType = z.infer<
  typeof DiscountCodeMessageDbParser
>;
